import React, { Component } from 'react';
import moment from 'moment';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { formatDate, toQueryParams } from 'admin/utils';
import {
  getSoftwareProductCodes,
  getSoftwareTargetHardwares,
  getSoftwares,
  clearSoftwares,
} from 'admin/actions/softwares';
import { createSoftwareRelease } from 'admin/actions/software-releases';
import LabeledSelect from 'admin/components/molecules/LabeledSelect';
import LabeledCheckBox from 'admin/components/molecules/LabeledCheckBox';
import LabeledRadio from 'admin/components/molecules/LabeledRadio';
import LabeledDateTimePicker from 'admin/components/molecules/LabeledDateTimePicker';
import TextBox from 'admin/components/atoms/TextBox';
import _Select, { addNullOption } from 'admin/components/atoms/Select';
import Switch from 'react-switch';
import NumberInput from 'admin/components/atoms/NumberInput';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import Button from 'admin/components/shared/Button';
import TableHeader from 'admin/components/shared/TableHeaders';
import TableRows from 'admin/components/shared/TableRows';
import Pager from 'admin/components/shared/Pager';
import CheckBox from 'admin/components/atoms/CheckBox';
import { openAlertModal, closeAlertModal } from 'admin/actions/alert-modal';
import FilterSelect from './FilterSelect';

const LabelText = styled.span`
  font-weight: 600;
`;

const FilterBox = styled.div`
  ${LabeledSelect} {
    display: block;
    margin: 15px;
    float: left;
  }
  ${_Select} {
    margin-left: 15px;
    width: 200px;
  }
  button {
    margin: 15px;
    float: right;
  }
`;

const Hr = styled.hr`
  clear: both;
  padding: 0;
  margin: 30px 0;
`;

const ListTableContainer = styled.div`
  margin: 0 20px;
`;

const ListTable = styled.div`
  margin-bottom: 30px;
`;

const ButtonsContainer = styled.div`
  margin: 30px 0;
  button {
    margin-right: 20px;
  }
`;

const NoResultText = styled.span`
  font-weight: 600;
  font-size: 20px;
  padding: 10px;
  text-align: center;
  display: block;
`;

const FilterRadioContainer = styled.div`
  display: flex;
  ${LabeledRadio} {
    flex-grow: 1;
    cursor: pointer;
  }
`;

const FilterDetail = styled.dl`
  padding-top: 20px;
  dt, dd {
    padding: 0 !important;
  }
  dd {
    padding-left: 10px !important;
  }
`;

const SettingBox = styled.div`
  dl {
    margin: 0;
  }
  dt, dd {
    padding: 20px;
    margin: 0;
  }
`;

const CreateSoftwareReleaseContainer = styled.div`
  h5 {
    font-weight: bold;
    margin: 20px;
  }
`;

const BuildInfoContainer = styled.div`
  dl {
    margin: 0;
  }
  dt, dd {
    padding: 10px 20px;
    margin: 0;
  }
`;

const FilterAvailableRate = styled.div`
  padding-left: 5px;
  font-weight: bold;
  ${NumberInput} {
    margin: 0 5px;
  }
`;

const FilterAvailableDate = styled.div`
  margin-top: 20px;
  ${CheckBox} {
    float: left;
  }
`;

const unselect = { label: '選択して下さい', value: null };

const defaultCreatingState = {
  software_id: null,
  description: '',
  is_enabled: false,
  priority: 0,
  is_force_update: false,
  available_rate: 100,
  available_from: null,
  organization_code: null,
  private_money_uuid: null,
  shop_uuid: null,
  terminal_uuid: null,
};

class CreateSoftwareRelease extends Component {

  constructor(props) {
    super(props);
    this.defaultPagination = { page: 1, per_page: 5 };
    this.state = Object.assign({
      selectedProductCode: unselect,
      selectedTargetHardware: unselect,
      currentPage: 1,
    }, defaultCreatingState);
  }

  componentWillMount() {
    this.props.clearSoftwares();
    this.props.getSoftwareProductCodes();
  }

  refreshSoftwares = (state) => {
    const params = Object.assign({}, this.defaultPagination, {
      productCode: state.selectedProductCode.value,
      targetHardware: state.selectedTargetHardware.value,
      page: state.currentPage,
    });
    this.props.getSoftwares(toQueryParams(params, true));
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.state.selectedProductCode !== nextState.selectedProductCode ||
        this.state.selectedTargetHardware !== nextState.selectedTargetHardware) {
      if (this.state.selectedProductCode !== nextState.selectedProductCode) {
        if (nextState.selectedProductCode.value) {
          this.props.getSoftwareTargetHardwares(nextState.selectedProductCode.value);
        }
        this.setState(Object.assign({
          selectedTargetHardware: unselect,
        }, defaultCreatingState));
      }
      if (nextState.selectedProductCode.value && nextState.selectedTargetHardware.value) {
        this.setState(defaultCreatingState);
        this.refreshSoftwares(nextState);
      } else {
        this.props.clearSoftwares();
      }
    }
  }

  onChangeProductCode = (op) => {
    this.setState({
      selectedProductCode: op,
    });
  }

  onChangeTargetHardware = (op) => {
    this.setState({
      selectedTargetHardware: op,
    });
  }

  onClickedNew = () => {
    const collectProps = (state, props) => {
      const rt = {};
      props.forEach((p) => {
        if (p in state && state[p] !== null) rt[p] = state[p];
      });
      return rt;
    };
    const params = collectProps(this.state, [
      'software_id',
      'description',
      'is_enabled',
      'priority',
      'is_force_update',
      'available_rate',
      'available_from',
      'organization_code',
      'private_money_uuid',
      'shop_uuid',
      'terminal_uuid',
    ]);
    if (params.available_from) {
      params.available_from = params.available_from.format();
    }
    this.props.openAlertModal({
      body: (
        <div>
          <strong>リリースを新しく登録しますか？</strong>
        </div>
      ),
      useCancel: true,
      confirmText: '登録する',
      onConfirm: () => {
        this.props.createSoftwareRelease(params).then(() => {
          this.props.openAlertModal({
            body: '完了しました',
            useCancel: false,
            onConfirm: () => {
              this.props.clearSoftwares();
              this.setState(defaultCreatingState);
            },
          });
        });
      },
    });
  }

  onChangePage = (page) => {
    this.setState({
      currentPage: page,
    }, () => this.refreshSoftwares(this.state));
  }

  onCheckSoftware = (checked, software_id) => {
    if (checked) {
      this.setState({ software_id });
    } else {
      this.setState({ software_id: null });
    }
  }

  onChangeAvailableRate = (e) => {
    this.setState({ available_rate: +(e.target.value) });
  }

  onChangeAvailableFrom = (date) => {
    this.setState({ available_from: date });
  }

  onChangePriority = (e) => {
    this.setState({ priority: +(e.target.value) });
  }

  onChangeDescription = (e) => {
    this.setState({ description: e.target.value });
  }

  onSelectFilterTypeAll = () => {
    this.setState({
      organization_code: null,
      private_money_uuid: null,
      shop_uuid: null,
      terminal_uuid: null,
    });
  }

  onSelectFilterTypeOrganization = () => {
    this.props.openAlertModal({
      body: (
        <FilterSelect
          target="organization"
          onSelectOrganization={(code, name) => {
            this.onSelectFilterTypeAll();
            this.setState({
              organization_code: code,
              organization_name: name,
            });
            this.props.closeAlertModal();
          }}
        />
      ),
      useCancel: false,
      useConfirm: false,
      styles: {
        content: {
          overflow: 'visible',
        },
      },
    });
  }

  onSelectFilterTypeMoney = () => {
    this.props.openAlertModal({
      body: (
        <FilterSelect
          target="money"
          onSelectPrivateMoney={(id, name) => {
            this.onSelectFilterTypeAll();
            this.setState({
              private_money_uuid: id,
              private_money_name: name,
            });
            this.props.closeAlertModal();
          }}
        />
      ),
      useCancel: false,
      useConfirm: false,
      styles: {
        content: {
          overflow: 'visible',
        },
      },
    });
  }

  onSelectFilterTypeShop = () => {
    this.props.openAlertModal({
      body: (
        <FilterSelect
          target="shop"
          onSelectShop={(id, name) => {
            this.onSelectFilterTypeAll();
            this.setState({
              shop_uuid: id,
              shop_name: name,
            });
            this.props.closeAlertModal();
          }}
        />
      ),
      useCancel: false,
      useConfirm: false,
      styles: {
        content: {
          overflow: 'visible',
        },
      },
    });
  }

  onSelectFilterTypeTerminal = () => {
    this.props.openAlertModal({
      body: (
        <FilterSelect
          target="terminal"
          onSelectTerminal={(id, name) => {
            this.onSelectFilterTypeAll();
            this.setState({
              terminal_uuid: id,
              terminal_name: name,
            });
            this.props.closeAlertModal();
          }}
        />
      ),
      useCancel: false,
      useConfirm: false,
      styles: {
        content: {
          overflow: 'visible',
        },
      },
    });
  }

  onClickedCancel = () => {
    this.props.history.goBack();
  }

  renderBuildInfo() {
    const software = this.props.softwares.rows.find(s => s.id === this.state.software_id);
    return (software) ? (
      <BuildInfoContainer>
        <h5>選択中のビルド</h5>
        <dl className="row">
          <dt className="col-sm-2">プロダクトコード</dt>
          <dd className="col-sm-10">{software.product_code}</dd>

          <dt className="col-sm-2">ハードウェア</dt>
          <dd className="col-sm-10">{software.target_hardware}</dd>

          <dt className="col-sm-2">バージョンコード</dt>
          <dd className="col-sm-10">{software.version_code}</dd>

          <dt className="col-sm-2">URL</dt>
          <dd className="col-sm-10">
            <a href={software.url}>
              {software.url}
            </a>
          </dd>

          <dt className="col-sm-2">登録日時</dt>
          <dd className="col-sm-10">
            {formatDate(software.created_at)}
          </dd>

          <dt className="col-sm-2">更新日時</dt>
          <dd className="col-sm-10">
            {formatDate(software.updated_at)}
          </dd>
        </dl>
      </BuildInfoContainer>
    ) : null;
  }

  renderSettingBox() {
    const filterType = {
      all: (
        !this.state.organization_code &&
        !this.state.private_money_uuid &&
        !this.state.shop_uuid &&
        !this.state.terminal_uuid
      ),
      organization: !!this.state.organization_code,
      private_money: !!this.state.private_money_uuid,
      shop: !!this.state.shop_uuid,
      terminal: !!this.state.terminal_uuid,
    };
    const filterDetail = (() => {
      if (filterType.all) return null;
      if (filterType.organization) {
        return (
          <FilterDetail className="row">
            <dt>対象組織</dt>
            <dd>{this.state.organization_name} ({this.state.organization_code})</dd>
          </FilterDetail>
        );
      }
      if (filterType.private_money) {
        return (
          <FilterDetail className="row">
            <dt>対象マネー</dt>
            <dd>{this.state.private_money_name} ({this.state.private_money_uuid})</dd>
          </FilterDetail>
        );
      }
      if (filterType.shop) {
        return (
          <FilterDetail className="row">
            <dt>対象店舗</dt>
            <dd>{this.state.shop_name} ({this.state.shop_uuid})</dd>
          </FilterDetail>
        );
      }
      return (
        <FilterDetail className="row">
          <dt>対象ターミナル</dt>
          <dd>{this.state.terminal_name} ({this.state.terminal_uuid})</dd>
        </FilterDetail>
      );
    })();
    return (
      <SettingBox>
        <h5>リリース設定</h5>
        <dl className="row">

          <dt className="col-sm-2">リリースの説明</dt>
          <dd className="col-sm-10">
            <TextBox
              syncValue={this.state.description}
              onChange={this.onChangeDescription}
              size={100}
            />
          </dd>

          <dt className="col-sm-2">対象絞り込み</dt>
          <dd className="col-sm-10">
            <FilterRadioContainer>
              <LabeledRadio
                name="filterType"
                onChange={this.onSelectFilterTypeAll}
                checked={filterType.all}
                labelText={(<LabelText>すべてを対象にする</LabelText>)}
                labelPosition="right"
              />
              <LabeledRadio
                name="filterType"
                onChange={this.onSelectFilterTypeOrganization}
                checked={filterType.organization}
                labelText={(<LabelText>組織で絞り込み</LabelText>)}
                labelPosition="right"
              />
              <LabeledRadio
                name="filterType"
                onChange={this.onSelectFilterTypeMoney}
                checked={filterType.private_money}
                labelText={(<LabelText>マネーで絞り込み</LabelText>)}
                labelPosition="right"
              />
              <LabeledRadio
                name="filterType"
                onChange={this.onSelectFilterTypeShop}
                checked={filterType.shop}
                labelText={(<LabelText>店舗で絞り込み</LabelText>)}
                labelPosition="right"
              />
              <LabeledRadio
                name="filterType"
                onChange={this.onSelectFilterTypeTerminal}
                checked={filterType.terminal}
                labelText={(<LabelText>特定ターミナル</LabelText>)}
                labelPosition="right"
              />
            </FilterRadioContainer>
            { filterDetail }
            <Hr />
            <FilterAvailableRate>
              上記の
              <NumberInput
                value={this.state.available_rate}
                onChange={this.onChangeAvailableRate}
                min={0}
                max={100}
              />
              ％を対象にリリース
            </FilterAvailableRate>
            <FilterAvailableDate>
              <LabeledCheckBox
                labelText={(<LabelText>即時リリース</LabelText>)}
                checked={!this.state.available_from}
                setChecked={(e) => {
                  if (!e) {
                    this.setState({ available_from: moment() });
                  } else {
                    this.setState({ available_from: null });
                  }
                }}
              />
              <br />
              <LabeledDateTimePicker
                labelText={(<LabelText>リリース日時</LabelText>)}
                value={this.state.available_from}
                onChange={this.onChangeAvailableFrom}
              />
            </FilterAvailableDate>
          </dd>

          <dt className="col-sm-2">リリースの優先度</dt>
          <dd className="col-sm-10">
            <NumberInput
              value={this.state.priority}
              onChange={this.onChangePriority}
            />
          </dd>

          <dt className="col-sm-2">強制アップデート</dt>
          <dd className="col-sm-10">
            <Switch
              checked={this.state.is_force_update}
              onChange={(checked) => {
                this.setState({ is_force_update: checked });
              }}
              width={65}
              height={30}
            />
          </dd>

          <dt className="col-sm-2">このリリースを有効化</dt>
          <dd className="col-sm-10">
            <Switch
              checked={this.state.is_enabled}
              onChange={(checked) => {
                this.setState({ is_enabled: checked });
              }}
              width={65}
              height={30}
            />
          </dd>
        </dl>
      </SettingBox>
    );
  }

  render() {
    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: 'サービス管理', href: '', active: true },
      { value: 'ソフトウェアリリース管理', href: '/service-settings/software-release', active: false },
      { value: '新規登録', href: '/service-settings/software-release/create', active: true },
    ];
    const columns = [
      { label: '選択', align: 'center', size: 0.3 },
      { label: 'バージョンコード', align: 'center', size: 1 },
      { label: '登録日時', align: 'center', size: 1 },
    ];
    const rows = this.props.softwares.rows.map(row => [
      {
        data: (
          <CheckBox
            onChange={e => this.onCheckSoftware(e.target.checked, row.id)}
            checked={this.state.software_id === row.id}
          />
        ),
        align: 'center',
      },
      { data: (<strong>{row.version_code}</strong>), align: 'center' },
      { data: (<span>{formatDate(row.created_at)}</span>), align: 'center' },
    ]);
    return (
      <CreateSoftwareReleaseContainer>
        <Breadcrumb items={crumb} />
        <h5>ビルドを選択</h5>
        <FilterBox>
          <LabeledSelect
            labelText={(<LabelText>プロダクト</LabelText>)}
            options={
            addNullOption(this.props.softwareProductCodes.map(m => ({
              label: m,
              value: m,
            })), '選択して下さい')
            }
            value={this.state.selectedProductCode}
            onChange={this.onChangeProductCode}
          />
          <LabeledSelect
            labelText={(<LabelText>ハードウェア</LabelText>)}
            options={
            addNullOption(this.props.softwareTargetHardwares.map(m => ({
              label: m,
              value: m,
            })), '選択して下さい')
            }
            value={this.state.selectedTargetHardware}
            onChange={this.onChangeTargetHardware}
          />
        </FilterBox>
        <Hr />
        {
          (!rows || rows.length === 0) ? (
            <NoResultText>結果がありません</NoResultText>
          ) : (
            <ListTableContainer>
              <ListTable>
                <TableHeader columns={columns} />
                <TableRows rows={rows} columns={columns} />
              </ListTable>
              <Pager
                pagination={this.props.softwares.pagination}
                onChangePage={this.onChangePage}
              />
            </ListTableContainer>
          )
        }
        {
          this.state.software_id ? (
            <div>
              <Hr />
              {this.renderBuildInfo()}
              <Hr />
              {this.renderSettingBox()}
              <Hr />
            </div>
          ) : null
        }
        {
          <ButtonsContainer>
            <Button onClick={this.onClickedNew} disabled={!this.state.software_id}>
              新しいリリースを登録
            </Button>
            <Button onClick={this.onClickedCancel} color="gray">
              キャンセル
            </Button>
          </ButtonsContainer>
        }
      </CreateSoftwareReleaseContainer>
    );
  }
}

CreateSoftwareRelease.defaultProps = {
  softwares: { rows: [], count: 0, pagination: { current: 1, per_page: 30 } },
  softwareProductCodes: [],
  softwareTargetHardwares: [],
};

const mapStateToProps = state => ({
  softwares: state.software.softwares,
  softwareProductCodes: state.software.softwareProductCodes,
  softwareTargetHardwares: state.software.softwareTargetHardwares,
});

CreateSoftwareRelease.propTypes = {
  openAlertModal: PropTypes.func.isRequired,
  closeAlertModal: PropTypes.func.isRequired,
  getSoftwareProductCodes: PropTypes.func.isRequired,
  getSoftwareTargetHardwares: PropTypes.func.isRequired,
  getSoftwares: PropTypes.func.isRequired,
  clearSoftwares: PropTypes.func.isRequired,
  createSoftwareRelease: PropTypes.func.isRequired,
  softwareProductCodes: PropTypes.arrayOf(PropTypes.string),
  softwareTargetHardwares: PropTypes.arrayOf(PropTypes.string),
  softwares: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      product_code: PropTypes.string,
      target_hardware: PropTypes.string,
      version_code: PropTypes.string,
      url: PropTypes.string,
      created_at: PropTypes.string,
      updated_at: PropTypes.string,
    })),
    count: PropTypes.number,
    pagination: PropTypes.shape({
      current: PropTypes.number,
      per_page: PropTypes.number,
    }),
  }),
  match: PropTypes.shape({
    params: PropTypes.object,
  }).isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  openAlertModal,
  closeAlertModal,
  getSoftwareProductCodes,
  getSoftwareTargetHardwares,
  getSoftwares,
  clearSoftwares,
  createSoftwareRelease,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CreateSoftwareRelease);
